/* eslint-disable react/jsx-max-depth */
import React from 'react';
import styled from 'styled-components';
import { SvgWrapper } from '../svg-wrapper';
var Svg = /*#__PURE__*/styled(SvgWrapper).withConfig({
  displayName: "checkmark-icon__Svg",
  componentId: "v1wkaj-0"
})(["width:126px;height:126px;color:", ";"], p => p.theme.colors.primary500);
export var CheckMark = (_ref) => {
  var {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 126 126",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-620.000000, -321.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(623.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: "5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "60",
    cy: "60",
    r: "60"
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "32 62.2452523 50.8773739 81.1226261 88 44"
  })))))));
};